import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { DataTableHeader } from "vuetify";
import { WorkSchedule } from "../UserMasterWorkSchedule";
import WeekdayContent from "./WeekdayContent.vue";
import UseWeeksContent from "./UseWeeksContent.vue";
import WorkScheduleDialogRegist from "./WorkScheduleDialogRegist.vue";
import WorkScheduleDialogEdit from "./WorkScheduleDialogEdit.vue";
import { useConfirm } from "@/plugins/confirm/confirm";
import DraggableTable from "@/components/DraggableTable.vue";

type Props = {
  value: WorkSchedule[];
  affiliationId?: number;
};
type Emits = {
  (e: "input", value: WorkSchedule[]): void;
  (e: "send"): void;
  (e: "edit", value: WorkSchedule): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'WorkScheduleTable',
  props: {
    value: null,
    affiliationId: null
  },
  emits: ["input", "send", "edit"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: "input", value: WorkSchedule[]): void;
  (e: "send"): void;
  (e: "edit", value: WorkSchedule): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  value: WorkSchedule[];
  affiliationId?: number;
};

const { $deleteConfirm } = useConfirm();

const headers: DataTableHeader[] = [
  { text: "曜日", value: "weekday", divider: true },
  { text: "シフト名", value: "shiftPatternName", divider: true },
  { text: "開始時間", value: "startTime", divider: true },
  { text: "終了時間", value: "endTime", divider: true },
  { text: "休憩時間", value: "restTime", divider: true },
  { text: "勤務時間", value: "diffTime", divider: true },
  { text: "週", value: "weeks", divider: true, sortable: false },
  {
    text: "編集",
    value: "edit",
    divider: true,
    width: "59",
    sortable: false,
    align: "center"
  },
  {
    text: "削除",
    value: "delete",
    width: "59",
    sortable: false,
    align: "center"
  }
];




const modelValue = computed({
  get: () => props.value,
  set: value => emits("input", value)
});

const isDisabled = computed(() => props.affiliationId == null);

const onRegist = () => {
  emits("send");
};
const onDelete = async (index: number) => {
  console.log(index);
  const confirm = await $deleteConfirm();
  if (confirm) modelValue.value.splice(index, 1);
};
const onAdd = (item: WorkSchedule) => {
  console.log(item);
  modelValue.value.push(item);
};
const onEdit = (item: WorkSchedule, index: number) => {
  console.log(item, index);
  modelValue.value.splice(index, 1, item);
};

return { __sfc: true,$deleteConfirm, headers, props, emits, modelValue, isDisabled, onRegist, onDelete, onAdd, onEdit, WeekdayContent, UseWeeksContent, WorkScheduleDialogRegist, WorkScheduleDialogEdit, DraggableTable }
}

})